export const EVENT_SITE_BRIEFING_JOB_CLICKED = 'site-briefing-job-clicked';
